export default {
	getRegex(pattern) {
		let regex = "";
		for (var i = 0; i < pattern.length; i++) {
			switch (pattern.charAt(i)) {
				case "a":
					regex += "[a-z]";
					break;
				case "A":
					regex += "[A-Z]";
					break;
				case "@":
					regex += "[a-Z]";
					break;
				case "#":
					regex += "\\d";
					break;
				case "&":
					regex += "([a-Z]|\\d)";
					break;
				case "*":
					regex += ".";
					break;
			}
		}
		console.log("Pattern:", regex);

		return new RegExp(`^${regex}$`);
	}
};



// WEBPACK FOOTER //
// ./src/services/ValidationPatternService.js